import { STORE_LOCATOR_CLOSE_INFOWINDOW_BUTTON } from '@/scripts/constants/css-classes'
import axios from 'axios'
import { BING, GOOGLE, NA } from '../constants/store-locator'
import { ZERO_PLACEHOLDER } from '@/scripts/constants/placeholders'

import { getRoeCookie } from './country-selector'
import { WcsStoreId } from './wcs/types/store-id'
import { NoEcommerce } from './no-ecommerce'
import { WcsAkamaiCookies } from './wcs/types/akamai-cookies'

export const coordinatesValidation = (value, vm) => {
  return !!vm && !!vm.latitude && !!vm.longitude && !!vm.location
}

export const loadExternalTranslations = async (language) => {
  const url = new URL(window.PUBLIC_PATH)
  const baseUrl = url.origin
  const endpoint = `${baseUrl}/rbstatichtml/translations/${language}.json`
  const response = await axios.get(endpoint)
  return response.data
}

export const getSearchStoresUrl = (storeId) => {
  const url = new URL(window.PUBLIC_PATH)
  const baseUrl = url.origin
  return `${baseUrl}/wcs/resources/store/${storeId}/search-stores`
}

export const getTooltipContent = (store, mapProvider) => {
  const {
    address: storeAddress = '',
    city: storeCity = '',
    latitude,
    longitude,
    postalCode: storePostalCode = '',
    telephone: storePhoneNumber = '',
  } = store

  const phoneNumberFunctionalityStyle =
    !!storePhoneNumber && storePhoneNumber !== NA
      ? ''
      : ' style="pointer-events:none; display:none"'
  const baseHTMLOutput = `
    <p class="info-window__store-name">${store.storeName}</p>
    <p class="info-window__store-address">
      ${storeAddress}, ${storePostalCode} - ${storeCity}
    </p>
    <div class="info-window__actions">
      <span class="info-window__action-call"${phoneNumberFunctionalityStyle}>
        <span class="common__icon common__icon--telephone-light">call</span>
        <a
          data-element-id="X_X_Store_Call"
          href="tel:${String(storePhoneNumber)}"
          target="_blank"
          referrerpolicy="no-referrer"
          class="info-window__telephone-number"
        >
          ${storePhoneNumber}
        </a>
      </span>
      <span data-element-id="X_X_Store_GetDirections" class="info-window__action-directions">
        <span class="common__icon common__icon--arrow-right-light">directions</span>
        <a
          href="${getStoreDirectionsLink(latitude, longitude, mapProvider)}"
          referrerpolicy="no-referrer"
          target="_blank"
          class="info-window__get-directions"
        >
        ${ZERO_PLACEHOLDER}
        </a>
      </span>
    </div>
    `

  const googleTooltipContent = `<span class="${STORE_LOCATOR_CLOSE_INFOWINDOW_BUTTON} common__icon common__icon--delete-light">close</span>${baseHTMLOutput}`
  const bingTooltipContent = `<div class="bing-info-container"><button class="${STORE_LOCATOR_CLOSE_INFOWINDOW_BUTTON} common__icon common__icon--delete-light">close</button> ${baseHTMLOutput}</div>`

  switch (mapProvider) {
    case GOOGLE:
      return googleTooltipContent
    case BING:
      return bingTooltipContent
    default:
      return ''
  }
}

export const getStoreDirectionsLink = (latitude, longitude, mapProvider) => {
  switch (mapProvider) {
    case GOOGLE:
      return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`
    case BING:
      return `https://bing.com/maps/?rtp=~pos.${String(latitude)}_${String(longitude)}`
    default:
      return ''
  }
}

export const filterCountriesByGroup = (countries) => {
  if (getRoeCookie()) {
    const roeCountries = countries.filter((country) => country.id === WcsStoreId.REST_OF_EUROPE)
    return roeCountries
  } else if (NoEcommerce.isAseanCountry()) {
    const aseanCountries = countries.filter((country) =>
      WcsAkamaiCookies.SOUTHEAST_ASIAN_NATIONS.includes(country.akamaiCC)
    )
    return aseanCountries
  } else if (NoEcommerce.isLatamCountry()) {
    const latamCountries = countries.filter((country) =>
      WcsAkamaiCookies.LATIN_AMERICA.includes(country.akamaiCC)
    )
    return latamCountries
  } else if (NoEcommerce.isSeeCountry()) {
    const seeCountries = countries.filter((country) =>
      WcsAkamaiCookies.SOUTHEAST_EUROPE.includes(country.akamaiCC)
    )
    return seeCountries
  } else if (NoEcommerce.isMeaCountry()) {
    const meaCountries = countries.filter((country) =>
      WcsAkamaiCookies.MIDDLE_EAST.includes(country.akamaiCC)
    )
    return meaCountries
  } else if (NoEcommerce.isInternationalCountry()) {
    const intCountries = countries.filter((country) =>
      WcsAkamaiCookies.INTERNATIONAL.includes(country.akamaiCC)
    )
    return intCountries
  } else if (NoEcommerce.isRowCountry()) {
    const rowCountries = countries.filter((country) =>
      WcsAkamaiCookies.REST_OF_WORLD.includes(country.akamaiCC)
    )
    return rowCountries
  }
}
